export default "__VITE_ASSET__DLtPEluD__"